import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Link from 'shared/components/Link';
import { withTranslate } from 'shared/hocs/withTranslate';
import logoPath from 'shared/assets/icons/logo.svg';
import logoUkPath from 'shared/assets/icons/logo_uk.svg';

import s from './Logo.css';

class Logo extends React.Component {
  static propTypes = {
    //
    t: PropTypes.func.isRequired,
  };
  static defaultProps = {};

  render() {
    const { t } = this.props;
    const logo = t('locale') === 'uk' ? logoUkPath : logoPath;
    return (
      <Link className={s.brandLogo} to={`/`}>
        <img
          src={logo}
          width={'155'}
          height={'36'}
          style={{ display: 'block' }}
          title={t('Купить и продать авто в Украине на Автобазар')}
          alt={t('Покупка и продажа авто в Украине на Автобазар')}
        />
      </Link>
    );
  }
}

export default withStyles(s)(withTranslate(Logo));



// WEBPACK FOOTER //
// ./src/shared/components/Logo/Logo.js